import { createFileRoute } from '@tanstack/react-router';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import api from '../lib/api';

export const Route = createFileRoute('/client/invites')({
  component: ClientInvitesPage,
});

function ClientInvitesPage() {
  const queryClient = useQueryClient();

  const { data: invites, isLoading } = useQuery<any[]>({
    queryKey: ['client-portal', 'my-invites'],
    queryFn: async () => {
      const r = await api.get('/client-portal/my-invites');
      return r.data?.data ?? r.data;
    },
  });

  const acceptMutation = useMutation({
    mutationFn: async (id: string) => {
      const r = await api.post(`/client-portal/my-invites/${id}/accept`);
      return r.data?.data ?? r.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['client-portal', 'my-invites'] });
      queryClient.invalidateQueries({ queryKey: ['client-portal', 'my-processes'] });
      queryClient.invalidateQueries({ queryKey: ['client-portal', 'my-feed'] });
    },
  });

  return (
    <div className="p-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
      <div className="max-w-4xl mx-auto bg-white rounded-[15px] p-5 shadow-sm border border-gray-100">
        <h1 className="text-[18px] font-semibold text-[#06141B]">Convites</h1>
        <p className="text-[12px] text-gray-500 mt-1">
          Aqui aparecem novos processos compartilhados com você que precisam ser aceitos.
        </p>

        {isLoading ? (
          <p className="text-sm text-gray-500 mt-4">Carregando convites...</p>
        ) : !invites?.length ? (
          <p className="text-sm text-gray-500 mt-4">Nenhum convite pendente.</p>
        ) : (
          <div className="mt-4 space-y-3">
            {invites.map((s) => (
              <div
                key={s.id}
                className="p-4 rounded-[12px] border border-gray-100 flex items-center justify-between gap-4"
              >
                <div className="min-w-0">
                  <p className="text-sm font-semibold text-[#06141B] truncate">
                    {s.process?.processNumber || 'Processo'}
                  </p>
                  <p className="text-xs text-gray-500 mt-1">
                    {s.createdAt ? new Date(s.createdAt).toLocaleString() : ''}
                  </p>
                </div>
                <button
                  type="button"
                  onClick={() => acceptMutation.mutate(s.id)}
                  disabled={acceptMutation.isPending}
                  className="px-4 py-2 rounded-[10px] text-sm font-medium bg-[#06141B] text-white hover:opacity-90 disabled:opacity-50"
                >
                  {acceptMutation.isPending ? 'Aceitando...' : 'Aceitar'}
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

